<template>
  <div class="">
    <create-cash-entries-deposit> </create-cash-entries-deposit>
  </div>
</template>

<script>
import CreateCashEntriesDeposit from "@/components/accounting/cash-entries/deposit/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    CreateCashEntriesDeposit,
  },
  created() {
    this.notifyQueue({
      text: "Crea Acconto",
      path: "movimenti_prima_nota.create2",
      level: 4,
    });
  },
};
</script>
